<template>
  <div class="modal fade" id="modal-update-completed" role="dialog" @click="$emit('close')">
    <div class="modal-dialog" @click.stop>
      <div class="modal-content">
        <div class="modal-header bg-color-info">
          <button type="button" class="close close-btn" data-dismiss="modal" @click="$emit('close')"> &times;</button>
        </div>
        <div class="modal-body">
          <span v-html="`登録が完了しました。`"></span>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-warning" data-dismiss="modal" @click="$emit('close')">ホーム画面へ</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    $('#modal-update-completed').modal('show')
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/updateRegisterInfo/ModalUpdateCompleted.vue